import { render } from "./TutorCardComponent.vue?vue&type=template&id=36139949"
import script from "./TutorCardComponent.vue?vue&type=script&lang=js"
export * from "./TutorCardComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__